// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".project-page .project-logo-wrapper {\n  margin-right: 16px;\n}\n", "",{"version":3,"sources":["webpack://./src/pages/SPReport.less"],"names":[],"mappings":"AACA;EAEI,kBAAA;AADJ","sourcesContent":["@import \"../../style/const\";\n.project-page {\n  .project-logo-wrapper {\n    margin-right: @spacing;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
